import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const FinanceNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/finance");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/finance",
      "/finance/fees-collection",
      "/finance/patients",
      "/finance/expenses-type",
      "/finance/expense-source",
      "/finance/expenses",
      "/finance/expense-payments",
      "/finance/approve",
      "/finance/report",
    ];
    if (validPaths.includes(path)) {
      setValue(path);
    } else if (
      path.startsWith("/finance/payment-collection") ||
      path.startsWith("/finance/medicine-payment")
    ) {
      setValue("/finance/fees-collection");
    } else if (path.startsWith("/finance/fees-collection")) {
      setValue("/finance/fees-collection");
    } else {
      setValue("/finance");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance" ? theme.palette.primary.main : "white",
                color: value === "/finance" ? "white" : "black",
              }}
              label={t("finance.dashboard")}
              value="/finance"
              component={NavLink}
              to="/finance"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/fees-collection"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/finance/fees-collection" ? "white" : "black",
              }}
              label={t("finance.feesCollection", { defaultValue: "Fees Collection" })}
              value="/finance/fees-collection"
              component={NavLink}
              to="/finance/fees-collection"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/patients"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/finance/patients" ? "white" : "black",
              }}
              label={t("finance.patients")}
              value="/finance/patients"
              component={NavLink}
              to="/finance/patients"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/expenses-type"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/finance/expenses-type" ? "white" : "black",
              }}
              label={t("finance.expenseType")}
              value="/finance/expenses-type"
              component={NavLink}
              to="/finance/expenses-type"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/expense-source"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/finance/expense-source" ? "white" : "black",
              }}
              label={t("finance.expenseSource")}
              value="/finance/expense-source"
              component={NavLink}
              to="/finance/expense-source"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/expenses"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/finance/expenses" ? "white" : "black",
              }}
              label={t("finance.expenses")}
              value="/finance/expenses"
              component={NavLink}
              to="/finance/expenses"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/expense-payments"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/finance/expense-payments" ? "white" : "black",
              }}
              label={t("finance.expensePayments")}
              value="/finance/expense-payments"
              component={NavLink}
              to="/finance/expense-payments"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/approve"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/finance/approve" ? "white" : "black",
              }}
              label={t("finance.approve")}
              value="/finance/approve"
              component={NavLink}
              to="/finance/approve"
            />
            {/* <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/finance/report"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/finance/report" ? "white" : "black",
              }}
              label={t("finance.report")}
              value="/finance/report"
              component={NavLink}
              to="/finance/report"
            /> */}
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default FinanceNav;
